const ANALYTICS_EVENT_CATEGORIES = {
  MENU_CURATOR_UPDATE_DISH: 'menu_curator_update_dish',
  MENU_CURATOR_KEYBOARD_SHORTCUTS: 'menu_curator_keyboard_shortcuts',
  MENU_CURATOR_LOAD_MENU_TASKS: 'menu_curator_load_menu_tasks',
  MENU_CURATOR_LOAD_MENU_TASK: 'menu_curator_load_menu_task',
  MENU_CURATOR_LOAD_DISHES: 'menu_curator_load_dishes',
  MENU_CURATOR_LOAD_UNKNOWN_WORDS: 'menu_curator_load_unknown_words',
  MENU_CURATOR_UPDATE_UNKNOWN_WORDS: 'menu_curator_update_unknown_words',
  MENU_CURATOR_UPDATE_MENU_TASK: 'menu_curator_update_menu_task',
}

export default ANALYTICS_EVENT_CATEGORIES
